import { ReactNode } from 'react';
import { ButtonProps } from '@wix/design-system';
import { ModalName } from '../../../constants/ModalName';

export type TModalOptionsState = {
  [modalName in ModalName]?: Partial<{
    isOpen: boolean;
    additionalOptions: any;
    closeParams: any;
  }>;
};

export enum ActionType {
  SetOpen = 'set-open',
  SetCloseParams = 'set-close-params',
}

export interface IModalOptionsAction {
  type: ActionType;
  payload: {
    modalName: ModalName;
    isOpen?: boolean;
    additionalOptions?: TAdditionalOptions;
    closeParams?: TCloseParams;
  };
}

export interface IModalOptionsContext {
  state: TModalOptionsState;
  openedModal: ModalName;
  openModal: (modalName: ModalName, additionalOptions?: TAdditionalOptions) => void;
  closeModal: (modalName: ModalName) => void;
  setCloseParams: (modalName: ModalName, closeParams?: TCloseParams) => void;
}

export enum Theme {
  Destructive = 'destructive',
  Premium = 'premium',
  Standard = 'standard',
}

export interface IModalOptions {
  content?: ReactNode;
  subtitle?: ReactNode;
  title?: ReactNode;
  image?: ReactNode;
  width?: string;
  height?: string;
  maxHeight?: string;
  overflowY?: string;
  confirmText?: ReactNode;
  cancelText?: ReactNode;
  primaryButtonProps?: Omit<ButtonProps, 'dataHook'>;
  secondaryButtonProps?: Omit<ButtonProps, 'dataHook'>;
  disableCancel?: boolean;
  disableConfirmation?: boolean;
  skin?: 'standard' | 'premium' | 'destructive';
  hideFooter?: boolean;
  noBodyPadding?: boolean;
  sideActions?: ReactNode;
  customLayout?: boolean;
  shouldCloseOnOverlayClick?: boolean;
  closeOnSubmit?: boolean;
  showHeaderDivider?: 'auto' | boolean;
  showFooterDivider?: 'auto' | boolean;
  shouldDisplayCloseButton?: boolean;
  onOpen?(additionalOptions: TAdditionalOptions): void;
  onOk?(additionalOptions: TAdditionalOptions): void;
  onAfterClose?(closeParams: TCloseParams): void;
  onClose?(closeParams: TCloseParams): void;
  onCancel?(additionalOptions: TAdditionalOptions): void;
  onCloseWithCloseButtonClick?(closeParams: TCloseParams): void;
  onCloseWithOverlayClick?(closeParams: TCloseParams): void;
  onHelpButtonClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export type TAdditionalOptions = { [key: string]: any };
export type TCloseParams = { [key: string]: any };
